import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
export var LinkedInConversionTracker = function() {
    var history = useHistory();
    useEffect(function() {
        return history.listen(function() {
            var referrer = document.referrer;
            if (referrer !== undefined && new RegExp('account-setup/researcher').test(referrer)) {
                window.lintrk('track', {
                    conversion_id: 7520412
                });
            }
        });
    });
    return null;
};
